import React from "react";
import {Select} from "./Select";
import {SelectId} from "./SelectId";

const regionalPricingModels = [
    { id: 'standard', label: 'Standard (2wk, 1 week at 75%)' },
    { id: '4wk:new-york', label: '4 week, 1 week at  80%, 2/3 week proportional' },
    {id: 'simplified',label:'Simplified (2wk, 1 week at 50%)'}
];

export const RegionTypePricingModel = (props) => {
    return props.valueIsId?<SelectId options={regionalPricingModels} {...props}  labelField="label" />:<Select options={regionalPricingModels} defaultOption={regionalPricingModels[0]['id']} {...props}  labelField="label" />;
}

